import React from "react";
import cx from "classnames";

import { Loading } from "@common/components/loading";
import { Field } from "./components/field";
import { FieldPickerField, FieldsProps } from "./fields.types";
import { trDts } from "@modules/datasheets/utils/i18n";

import "./fields.styles.scss";

export const Fields: React.FC<FieldsProps> = (props) => {
  const { fields, loading, className, selection, style, dndType, isFieldAdded } = props;

  const handleFieldClickUp = React.useCallback(({ item, event }: { item: FieldPickerField; event: React.MouseEvent<HTMLDivElement> }) => {
    const alreadySelectedItems = selection.items;
    let newSelectedItems = [item];
    
    if (!(event.ctrlKey || event.shiftKey) && alreadySelectedItems.length > 1) {
      selection.onChange(newSelectedItems);
    }
  },
  [selection]);

  const handleFieldClickDown = React.useCallback(({ item, event }: { item: FieldPickerField; event: React.MouseEvent<HTMLDivElement> }) => {
    const alreadySelectedItems = selection.items;
    
    if (!(event.ctrlKey || event.shiftKey) && alreadySelectedItems.length > 1) {
      return;
    }
    
    let newSelectedItems = [item];
    const isAlreadySelected = alreadySelectedItems.some((x) => x.id === item.id);
    
    if ((event.ctrlKey || event.shiftKey)) {
      newSelectedItems = isAlreadySelected
        ? alreadySelectedItems.filter((x) => x.id !== item.id)
        : alreadySelectedItems.concat(item);
    } else if (alreadySelectedItems.length === 1 && isAlreadySelected) {
      return;
    }

    selection.onChange(newSelectedItems);
  }, [selection]);

  const isFieldSelected = React.useCallback((item: FieldPickerField) => {
    return selection.items.some((x) => x.id === item.id) ?? false;
  }, [selection.items]);

  return (
    <div className={cx("DatasheetsEditorFields", className)} style={style}>
      {loading && <Loading size={20} margin="20px" />}
      {!loading && !fields.length && (
        <div className="DatasheetsEditorFields__no-data-message">{trDts("Please select the folder or search fields")}</div>
      )}
      {!loading && fields.length > 0 && (
        <div className="DatasheetsEditorFields__list">
          {fields.map((field) => (
            <Field
              key={field.id}
              dndType={dndType}
              field={field}
              isAdded={isFieldAdded(field)}
              onMouseUp={handleFieldClickUp}
              onMouseDown={handleFieldClickDown}
              isSelected={isFieldSelected(field)}
            />
          ))}
        </div>
      )}
    </div>
  );
};
